import filterTypes from '../actions/filter.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        case filterTypes.STORE_FILTERS:
            
            let conditions = [...state.conditions];
            const index = conditions.findIndex((item) => item.id === action.payload.filters.id);

            if (index === -1) {
                return {
                    ...state,
                    conditions: [...state.conditions, action.payload.filters]
                };

            } else {
                
                conditions[index] = { ...action.payload.filters };
                return {
                    ...state,
                    conditions
                }
            }
            

        case filterTypes.REMOVE_FILTER:
            return {
                ...state,
                conditions: state.conditions.filter((filter) => filter.parentId !== action.payload.id)
            };

        case filterTypes.REMOVE_ALL:
            return {
                ...state,
                conditions: []
            };

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    conditions: []
};